// Componente que muestra el título "Panel de Administración" en la interfaz de administración.

const AdminTitle = () => {
    return(
        <div>
            <h2 className="cartcheckout__title">Panel de Administración</h2>
        </div>
    )
}

export default AdminTitle;